<template>
    <!-- a section of a page: the title next to the slanted teal-to-blue tick of the league -->
    <div class="cl-section-heading" :class="{ 'cl-section-heading--light': light }">
        <span class="cl-section-heading__tick" />
        <v-icon v-if="icon" class="cl-section-heading__icon" small>{{ icon }}</v-icon>
        <h2 class="cl-section-heading__title">{{ title }}</h2>
        <span v-if="count !== null" class="cl-section-heading__count">{{ count }}</span>
        <v-spacer />
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'SectionHeading',
        props: {
            title: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                default: null
            },
            count: {
                type: [Number, String],
                default: null
            },
            // on a dark background
            light: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
.cl-section-heading {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin: 0 0 14px;
    text-align: left;
    color: #232323;
}

.cl-section-heading__tick {
    width: 12px;
    height: 26px;
    flex: 0 0 auto;
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    transform: skewX(-18deg);
    border-radius: 2px;
}

.cl-section-heading__icon {
    color: #009688 !important;
}

.cl-section-heading__title {
    margin: 0;
    white-space: nowrap;
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 1.9rem;
    font-weight: 400;
    line-height: 1;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.cl-section-heading__count {
    padding: 1px 9px;
    border-radius: 10px;
    background: #232323;
    color: #fff;
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
}

.cl-section-heading--light {
    color: #fff;
}

.cl-section-heading--light .cl-section-heading__count {
    background: rgba(255, 255, 255, 0.15);
}

@media (max-width: 700px) {
    .cl-section-heading__title {
        font-size: 1.5rem;
    }
}
</style>
